<script setup lang="ts">
import type {Testimonial} from '~/types/legacy'
import type {Populated} from '~/types/populated'

defineProps<{
  testimonials: Populated<Testimonial>[]
}>()
</script>

<template>
  <div class="mt-16 sm:columns-2 md:columns-3">
    <TestimonialCard
      v-for="item of testimonials"
      :key="item.id"
      :testimonial="item"
      class="mb-4 w-full !break-inside-avoid"
    />
  </div>
</template>
